@if (icon) {
  <fa-icon
    [icon]="icon"
    class="icon-label__icon"
    [class.icon-label__icon--colored]="colored"
    [fixedWidth]="fixedWidth"
  ></fa-icon>
}
<span>{{ label }}</span>
